export default "__VITE_ASSET__8ca9efc5__"